import React from 'react';

export default function LoadingSpinner({ message = 'Loading…', fullPage = false }) {
  if (fullPage) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center min-h-64 gap-3">
        <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full spinner" />
        <p className="text-slate-500 text-sm">{message}</p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center gap-2 py-8">
      <div className="w-6 h-6 border-3 border-blue-600 border-t-transparent rounded-full spinner" />
      <span className="text-slate-500 text-sm">{message}</span>
    </div>
  );
}
